export default "__VITE_ASSET__Y9rxaP5B__"